<!--
 * @Author: your name
 * @Date: 2021-06-01 10:29:25
 * @LastEditTime: 2021-10-15 11:32:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\MediaItem.vue
-->
<template>
	<div class="program-item" ref="mediaBox">
		<div class="program-img" ref="mediaComponents">
			<img v-if="program.damaged === 0" class="p-img" :src="program.pimg" alt />
			<img v-else class="p-img" src="@imgpub/damaged.png" alt />
			<span class="p-time">{{program.size_remark}}</span>
			<img class="bindnum" v-if="program.published > 0" src="@imgpub/icon_yinyong.png" alt />
			<div class="p-select" :class="{'p-select-a':mediaChecked}">
				<el-checkbox v-model="mediaChecked" @change="checkboxChange"></el-checkbox>
			</div>
			<div class="program-control" v-if="this.program.damaged==0">
				<img src="@/assets/images/public/public_release.png" @click="programRelease" />
				<img src="@/assets/images/public/public_edit.png" @click="programEdit"
					v-if="this.program.is_edit===1" />
				<img src="@/assets/images/public/public_detail.png" @click="programDetail"
					v-if="this.program.is_edit === 0" />
				<img src="@/assets/images/public/public_delete.png" @click="programDelete" />
			</div>
			<div class="mask"></div>
		</div>
		<div class="program-title ellipsis-1" :title="`${program.name}`">{{`${program.name}`}}</div>
	</div>
</template>

<script>
	export default {
		name: 'MediaItem',
		props: {
			program: {
				type: Object,
				default: () => {}
			},
			isSelected: {
				type: Boolean,
				default: false
			},
		},
		data() {
			return {
				mediaChecked: false,
				isMenuList: false
			}
		},
		methods: {
			checkboxChange(val) {
				console.log(val);
				this.$emit("setSelectMedia", val, this.program.id);
			},
			programRelease() {
				this.$emit('programControl', this.program, 'publish')
			},
			programEdit() {
				this.$emit('programControl', this.program, 'edit')
			},
			programDetail() {
				this.$emit('programControl', this.program, 'detail')
			},
			programDelete() {
				this.$emit('programControl', this.program, 'delete')
				//this.delProgramIds = this.program.id;
				//this.DelDialogVisible = true;
			}
		},
		watch: {
			isSelected: {
				handler(nVal) {
					this.mediaChecked = nVal;
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.program-item {
		position: relative;
		width: 100%;
		border-radius: 4px;
		overflow: hidden;

		.program-img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			padding-top: 56%;
			position: relative;

			.p-img {
				position: absolute;
				top: 0;
				left: 0;
				width: 100%;
				height: 100%;
				pointer-events: none;
				user-select: none;
			}

			.p-time {
				position: absolute;
				right: 0px;
				bottom: 0px;
				color: #ccc;
			}

			.bindnum {
				width: 20px;
				position: absolute;
				right: 0px;
				top: 0px;
				background: #fff;
				border-radius: 10px;
			}

			.p-select {
				position: absolute;
				left: 2px;
				top: 0px;
				opacity: 0;
				z-index: 10000;
			}

			.p-select-a {
				opacity: 1;
			}

			.program-control {
				width: 100%;
				z-index: 1100;
				position: absolute;
				display: flex;
				align-items: center;
				justify-content: space-around;
				//background-color: orange;
				top: 50%;
				transform: translateY(-50%);

				img {
					height: 100%;
					width: 25px;
				}

				display: none;
			}

			.mask {
				position: absolute;
				left: 0;
				top: 0;
				z-index: 999;
				width: 100%;
				height: 100%;
				background-color: rgba(200, 200, 200, 0.5);
				display: none;
			}
		}

		.program-img:hover .program-control {
			display: flex;
			align-items: center;
			justify-content: space-around;
		}

		.program-img:hover .mask {
			display: block;
		}

		.program-img:hover .p-select {
			opacity: 1;
		}

		.program-title {
			width: calc(100% - 8px);
			line-height: 26px;
			background-color: #eefbff;
			font-size: 16px;
			padding: 0px 4px;
			user-select: none;
		}
	}
</style>
